import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { TECHNICAL_SHEET_OVERRIDE_INPUT } from '../types/technical-sheet-override-input.js';
/**
 * Descriptor for TechnicalSheetOverrideInput.
 * Subcollection: org/{orgId}/technical-sheet-override/{overrideId}/input
 *
 * Resolve with context: { orgId, overrideId }.
 */
export const technicalSheetOverrideInputDescriptor = {
    name: TECHNICAL_SHEET_OVERRIDE_INPUT,
    label: 'Insumo do Override',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/technical-sheet-override/{overrideId}/input',
    pathPatternKeys: { orgId: 'string', overrideId: 'string' },
    version: 1,
    description: 'Insumo adicionado, removido ou alterado pelo override (locator: processId + componentId)',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        // NoCache: filho de entidade versionada (spec 0045) — itens em cache voltariam velhos após Recarregar e seriam regravados por cima.
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        { name: 'action', label: 'Ação', type: 'string', required: true },
        { name: 'processId', label: 'Processo', type: 'string', required: true },
        { name: 'componentId', label: 'Componente', type: 'string', required: true },
        { name: 'productId', label: 'Produto (insumo)', type: 'string', required: false },
        { name: 'variantId', label: 'Variante', type: 'string', required: false },
        { name: 'quantity', label: 'Quantidade', type: 'number', display: 'quantity', required: false },
        { name: 'consumptionType', label: 'Tipo de consumo', type: 'string', required: false },
        { name: 'quantityPerBatchOrFixed', label: 'Quantidade por lote/fixo', type: 'number', display: 'quantity', required: false },
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        {
            fieldName: 'processId',
            targetEntity: 'Process',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Processo onde o insumo vive',
        },
        {
            fieldName: 'componentId',
            targetEntity: 'Component',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Chave de localização do insumo (business key)',
        },
        {
            fieldName: 'productId',
            targetEntity: 'Product',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Produto (insumo); obrigatório em ADD/UPDATE',
        },
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Variante do produto vinculada ao insumo (opcional)',
        },
        ...AUDIT_FOREIGN_KEYS,
    ],
};
//# sourceMappingURL=technical-sheet-override-input.descriptor.js.map